var BxfNotificationBadgeTypeEnum;
(function (BxfNotificationBadgeTypeEnum) {
    BxfNotificationBadgeTypeEnum["ERROR"] = "error";
    BxfNotificationBadgeTypeEnum["WARNING"] = "warning";
    BxfNotificationBadgeTypeEnum["SUCCESS"] = "success";
    BxfNotificationBadgeTypeEnum["MESSAGE"] = "neutral";
})(BxfNotificationBadgeTypeEnum || (BxfNotificationBadgeTypeEnum = {}));

var BxfNotificationFooterTypeEnum;
(function (BxfNotificationFooterTypeEnum) {
    BxfNotificationFooterTypeEnum["BUTTON"] = "button";
    BxfNotificationFooterTypeEnum["LINK"] = "link";
})(BxfNotificationFooterTypeEnum || (BxfNotificationFooterTypeEnum = {}));

var BxfNotificationToastTypeEnum;
(function (BxfNotificationToastTypeEnum) {
    BxfNotificationToastTypeEnum["TIMEOUT"] = "timeout";
    BxfNotificationToastTypeEnum["PERSISTENT"] = "persistent";
})(BxfNotificationToastTypeEnum || (BxfNotificationToastTypeEnum = {}));

class BxfNotificationConstants {
    static STRING = {
        CONTAINER_SHOW: 'bxf-notification__container--show',
        CONTAINER_HIDE: 'bxf-notification__container--hide',
        CONTAINER_COMPACT: 'bxf-notification__container--compact',
        CONTENT: 'bxf-notification__content',
        BUTTONS: 'bxf-notification__buttons',
        BADGE: 'bxf-notification__badge',
        BADGE_MESSAGE: 'bxf-notification__badge--message',
        BADGE_COMPACT: 'bxf-notification__badge--compact',
        CONTAINER_CONTENT_BUTTON: 'bxf-notification__content-button-container',
        CONTENT_WITH_BUTTON: 'bxf-notification__content-button',
        CONTENT_WITH_BUTTON_COMPACT: 'bxf-notification__content-button--compact',
        CONTAINER: 'bxf-notification__container',
        CLOSE_BUTTON: 'bxf-notification__close-button',
        CLOSE_BUTTON_LABEL: 'close',
        MESSAGE_LIST: 'bxf-notification__message-list',
        HEADER_PLURAL: 's',
        MESSAGE_HEADER: 'bxf-notification__message-header',
        MESSAGE_HEADER_COMPACT: 'bxf-notification__message-header--compact',
        MULTI_MESSAGE_CONTAINER: 'bxf-notification__multi-message-container',
        MESSAGE_BODY: 'oneds-blk-body-xs',
    };
}

export { BxfNotificationBadgeTypeEnum as B, BxfNotificationFooterTypeEnum as a, BxfNotificationToastTypeEnum as b, BxfNotificationConstants as c };
